// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Online_wrapper__3Qh7C","title":"Online_title__fsgFl","content":"Online_content__3uSSQ","card":"Online_card__2HA4h"};